import { Alert, AlertProps, AlertTitle } from '@mui/material';
import styled from 'styled-components';
import {
  faCircleExclamation, faCircleInfo, faCircleCheck, faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StyledAlert = styled(Alert)`
    && {
        font-family: 'Poppins Light', 'Poppins', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0;
    }
`;

const StyledAlertTitle = styled(AlertTitle)`
    && {
        font-family: 'Poppins Light', 'Poppins', sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0;
    }
`;

interface CrioAlertProps extends AlertProps {
  description: string;
}

function CrioAlert({
  severity, title, description, ...rest
}: Readonly<CrioAlertProps>) {
  return (
    <StyledAlert
      severity={severity}
      iconMapping={{
        error: <FontAwesomeIcon icon={faCircleExclamation} />,
        info: <FontAwesomeIcon icon={faCircleInfo} />,
        success: <FontAwesomeIcon icon={faCircleCheck} />,
        warning: <FontAwesomeIcon icon={faTriangleExclamation} />,
      }}
      {...rest}
    >
      <StyledAlertTitle>{title}</StyledAlertTitle>
      {description}
    </StyledAlert>
  );
}

export default CrioAlert;
